import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=dfff2ec0"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfff2ec0')) {
      api.createRecord('dfff2ec0', component.options)
    } else {
      api.reload('dfff2ec0', component.options)
    }
    module.hot.accept("./Icons.vue?vue&type=template&id=dfff2ec0", function () {
      api.rerender('dfff2ec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Components/Icons.vue"
export default component.exports